module.exports = __webpack_public_path__ + "img/icon_report_off.57740958.svg";